import React from 'react';

const DownloadButton = ({ episodeSrc }) => {
    return (
        <a aria-label="Download" target="_blank" href={episodeSrc} className="episode-player-download" download rel="noreferrer">
            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.33398 7L8.00065 9.66667M8.00065 9.66667L10.6673 7M8.00065 9.66667V3.53333C8.00065 2.6062 8.00065 2.14263 7.63364 1.6236C7.38979 1.27874 6.6877 0.853119 6.26917 0.796414C5.63924 0.711068 5.40003 0.835854 4.9216 1.08543C2.78954 2.19762 1.33398 4.42883 1.33398 7C1.33398 10.6819 4.31875 13.6667 8.00065 13.6667C11.6826 13.6667 14.6673 10.6819 14.6673 7C14.6673 4.53239 13.3267 2.37791 11.334 1.22522" stroke="#321A51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </a>
    );
};

export default DownloadButton;
